import * as React from 'react';
import { themr } from 'react-css-themr';
import { Icon } from '@joehua/buzz-components';
import { Link } from '@joehua/react-link';
const DumpNav = ({ items, theme = {}, onClick }) => {
    return (React.createElement("ul", { className: theme.root }, items.map((item, idx) => {
        return (React.createElement("li", { className: theme.itemWrapper, key: idx },
            React.createElement(Link, { className: theme.itemLink, activeClassName: theme.activeItemLink, href: item.href, to: item.to, title: item.label, onClick: () => {
                    if (onClick) {
                        onClick(item);
                    }
                } },
                item.icon && React.createElement(Icon, { className: theme.icon, icon: item.icon }),
                item.label && React.createElement("span", { className: item.label }, item.label))));
    })));
};
export const defaultNavTheme = {
    root: 'list pl0 ma0 flex flex-column',
    itemLink: 'dib f6 fw7 ttu ph3 pv2 white-80 hover-rc',
    activeItemLink: 'rc',
};
const Nav = themr('Nav', {}, { composeTheme: 'softly' })(DumpNav);
export default Nav;
//# sourceMappingURL=index.js.map